import * as React from 'react';
import {PropsWithChildren} from 'react';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import {Theme, useMediaQuery, useTheme} from '@mui/material';
import {Breakpoint, SxProps} from '@mui/system';
import {useModals} from '../../../hooks/useModalStack';
import AppDialogContent, {AppDialogContentProps} from './AppDialogContent.tsx';
import {voidFunction} from '../../../lib/event.ts';

export const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type Props = PropsWithChildren<{
    onClose?: () => void;
    maxWidth?: Breakpoint | false;
    open?: boolean | undefined;
    sx?: SxProps<Theme>;
    rawContent?: boolean;
    preventClose?: boolean;
}> &
    Omit<AppDialogContentProps, 'onClose' | 'children'>;

export type {Props as AppDialogProps};

export default function AppDialog({
    preventClose,
    children,
    open = true,
    rawContent,
    onClose,
    maxWidth = 'md',
    sx,
    ...contentProps
}: Props) {
    const {closeModal} = useModals();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = () => {
        closeModal();
        onClose?.();
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            onClose={preventClose ? voidFunction : handleClose}
            open={open}
            fullWidth={true}
            maxWidth={maxWidth}
            sx={sx}
        >
            {rawContent ? (
                children
            ) : (
                <AppDialogContent onClose={handleClose} {...contentProps}>
                    {children}
                </AppDialogContent>
            )}
        </BootstrapDialog>
    );
}
